import React from 'react';
import PropTypes from 'prop-types';
import { StickyNav } from '../../molecules';
import { Button, IconButton } from '../../atoms';
import {
  BackColumn,
  ButtonContainer,
  ContinueColumn,
  StyledCheckoutBar,
} from './styles';
import { Pricing } from './Pricing';

export const CheckoutBar = ({
  shown,
  ctaText,
  amount,
  discountedAmount,
  period,
  disabled = false,
  onBackButtonClick,
  isSubmitting = false,
}) => {
  return (
    <StickyNav shown={shown}>
      <StyledCheckoutBar>
        <ButtonContainer>
          {onBackButtonClick && (
            <BackColumn>
              <IconButton
                aria-label="go to previous step"
                icon={{ iconName: 'arrow-left', size: '24px', alt: 'back' }}
                onClick={onBackButtonClick}
                type="button"
                variant="spinach"
              />
            </BackColumn>
          )}
          <ContinueColumn>
            {
              // TODO(James) refactor this into a `pricing` object
              amount && discountedAmount && (
                <Pricing
                  amount={amount}
                  discountedAmount={discountedAmount}
                  period={period}
                />
              )
            }
            <Button
              disabled={disabled}
              fullWidth
              variant="spinach"
              isLoading={isSubmitting}
            >
              {ctaText}
            </Button>
          </ContinueColumn>
        </ButtonContainer>
      </StyledCheckoutBar>
    </StickyNav>
  );
};

CheckoutBar.displayName = 'CheckoutBar';

CheckoutBar.propTypes = {
  shown: PropTypes.bool.isRequired,
  ctaText: PropTypes.string.isRequired,
  amount: PropTypes.string,
  discountedAmount: PropTypes.string,
  period: PropTypes.string,
  disabled: PropTypes.bool,
  isSubmitting: PropTypes.bool,
  onBackButtonClick: PropTypes.func,
};
